import React, { useState, useEffect } from "react";
import logo from "../assets/vignan_online.png";
import hamberger from "../assets/hamberger.png";
import desktopbanner from "../assets/referral-website-banner.gif"
import mobilebanner from '../assets/Mobile1.gif'
import student from "../assets/referrer.jpeg";
import amazon from "../assets/Amazon_Voucher.png";
import documentPen from "../assets/document_with_pen_Zxl4TSiYS.png";
import peopleConnecting from "../assets/people_connecting_gK6Ou2mH2.png";
import giftCard from "../assets/gift_card_ADP9BTEiz.png";
import redeemRewards from "../assets/Redeem_your_rewards.png";
import facebook from "../assets/Icon awesome-facebook.svg";
import instagram from "../assets/Icon awesome-instagram.svg";
import linkedin from "../assets/Icon awesome-linkedin.svg";
import youtube from "../assets/Icon awesome-youtube.svg";
import x from "../assets/logo.svg";
import { useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthContext.jsx";
import { useCampaign } from '../Context/CampaignContext.jsx';

const Home = () => {
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeInnerIndex, setActiveInnerIndex] = useState({});
  const { user } = useAuth();
  const location = useLocation();
  const { saveCampaignData } = useCampaign();

  const getQueryParams = (key) => {
    const params = new URLSearchParams(location.search);
    return params.get(key);
  };

  const campaign = getQueryParams("utm_campaign") || "NA";
  const source = getQueryParams("utm_source") || "NA";
  const medium = getQueryParams("utm_medium") || "NA";

  useEffect(() => {
    saveCampaignData(source, campaign, medium);
  }, [source, campaign, medium, saveCampaignData]);

  const refferalBenifits = [
    {
      id: 1,
      image: documentPen,
      title: "Create Account",
      content:
        "Quickly log in to your account using the VISA registered email credentials.",
      count: "01",
    },
    {
      id: 2,
      image: peopleConnecting,
      title: "Start Referring",
      content:
        "Upon logging in, add the basic details of the individual/s you'd like to refer.",
      count: "02",
    },
    {
      id: 3,
      image: giftCard,
      title: "Get Benefits",
      content:
        "Once your referral successfully enrolls and qualifies, points will be added to your account.",
      count: "03",
    },
    {
      id: 4,
      image: redeemRewards,
      title: "Redeem Vouchers",
      content:
        "Redeem your points against 100+ brand options on the rewards marketplace.",
      count: "04",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleInnerAccordion = (outerIndex, innerIndex) => {
    setActiveInnerIndex((prevState) => ({
      ...prevState,
      [outerIndex]: prevState[outerIndex] === innerIndex ? null : innerIndex,
    }));
  };

  const faqMcq = [
    {
      title: "Eligibility Criteria",
      Insidecontent: [
        {
          insideContentTitle:
            "What are the eligibility criteria to receive a Referral Bonus?",
          insideContentContent:
            "It could be either or both -<br> • The referee has successfully enrolled in a program.<br > • The referee has cleared the admission and verification process.",
        },
        {
          insideContentTitle:
            "Do I need to be a VIGNAN learner to refer my friends?",
          insideContentContent:
            "Yes. Currently, the referral program is only open for VIGNAN Online learners.",
        },
      ],
    },
    {
      title: "How to Refer",
      Insidecontent: [
        {
          insideContentTitle: "How can I refer my friends/connections?",
          insideContentContent:
            "If you've already enrolled with VIGNAN: <br /> • Fill out the basic details of the individual/s you'd like to refer.<br /> • Alternatively, share the referral invite link with them.<br /><br /> If you haven't signed up with VIGNAN yet:<br /> • Sign up first, then proceed with the steps mentioned above.",
        },
      ],
    },
    {
      title: "Payouts & Rewards",
      Insidecontent: [
        {
          insideContentTitle:
            "When can I expect to receive the referral points?",
          insideContentContent:
            "Once the referee meets the required eligibility criteria, our team will add the points to your dashboard, which can be redeemed at our exclusive rewards marketplace.",
        },
        {
          insideContentTitle: "I have still not received my referral bonus",
          insideContentContent:
            "That could be because - <br /> • The referee might not have completed the enrollment process. <br /> • The admission has been rejected due to ineligibility.",
        },
      ],
    },
  ];

  const handleHamburgerClick = () => {
    setIsButtonVisible((prevState) => !prevState);
  };

  // Helper component for CTA Buttons
  const CTAButton = ({ href, text, primary = false }) => (
    <a href={href} className="inline-block z-10 relative">
      <div className={`text-[15px] px-8 py-3 rounded-lg font-semibold transition-all transform hover:-translate-y-0.5 ${primary
        ? "bg-red-600 text-white hover:bg-red-700"
        : "bg-white text-red-600 border border-red-200 hover:border-red-600"
        }`}>
        {text}
      </div>
    </a>
  );

  return (
    <div className="font-sans antialiased text-gray-900 bg-gray-50 flex flex-col min-h-screen">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <a href="/" className="flex-shrink-0 transition-opacity hover:opacity-90">
              <img src={logo} alt="Vignan Online" className="h-10 w-auto" />
            </a>

            <div className="hidden md:flex items-center space-x-4">
              {user === null && <CTAButton href="/login" text="Login" />}
              {["Student", "ExternalVisitor"].includes(user?.user_type) && <CTAButton href="/student" text="Dashboard" />}
              {["Admin", "SalesHead", "SalesCounselor"].includes(user?.user_type) && (
                <CTAButton href="/sales" text="Sales Dashboard" />
              )}
            </div>

            <div className="md:hidden p-2 -mr-2 cursor-pointer rounded-md hover:bg-gray-100" onClick={handleHamburgerClick}>
              <img src={hamberger} alt="Menu" className="h-6 w-6" />
            </div>
          </div>

          {/* Mobile Menu */}
          {isButtonVisible && (
            <div className="md:hidden py-4 border-t border-gray-100 animate-fadeIn">
              {user === null && <div className="flex justify-center"><CTAButton href="/login" text="Login" primary /></div>}
            </div>
          )}
        </div>
      </header>

      <main className="flex-grow">
        {/* Banner Section */}
        <section className="bg-white">
          <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto">
            <a href="https://shorturl.at/k67kG" className="block w-full transition-opacity hover:opacity-95">
              <picture>
                <source media="(min-width: 768px)" srcSet={desktopbanner} />
                <img src={mobilebanner} alt="Referral Program Banner" className="w-full h-auto" />
              </picture>
            </a>
          </div>
        </section>

        {/* Referrer of the Month Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl 2xl:max-w-[90rem] mx-auto">
          <div className="bg-white rounded-3xl  overflow-hidden border border-gray-100 transition-all">
            <div className="flex flex-col lg:flex-row items-stretch">

              {/* Image Column - Optimized for alignment */}
              <div className="lg:w-3/12 w-full relative h-[450px] md:h-[650px] lg:h-auto bg-gray-100 group">
                <img
                  src={student}
                  alt="Referrer of the Month"
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent lg:hidden"></div>

                {/* Mobile Overlay Text */}
                <div className="absolute bottom-6 left-6 text-white lg:hidden">
                  <div className="font-bold text-xl mb-1">Kinneresh</div>
                  <div className="text-sm opacity-90 font-light tracking-wide bg-black/20 backdrop-blur-sm px-3 py-1 rounded-full w-max">MBA (Healthcare and hospital management)</div>
                </div>
              </div>

              {/* Content Column */}
              <div className="lg:w-9/12 w-full p-6 lg:p-10 xl:p-12 flex flex-col justify-center text-center lg:text-left bg-white relative z-10">
                {/* Decorative Badge */}
                <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
                  <span className="flex h-3 w-3 relative">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600"></span>
                  </span>
                  <span className="text-xs font-bold tracking-widest text-red-600 uppercase">Referrer of the Month</span>
                </div>

                <h2 className="text-2xl lg:text-3xl xl:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                  Refer Friends and&nbsp;
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-400">Earn Real Rewards</span>
                </h2>

                {/* Quote Box */}
                <div className="bg-gray-50 p-5 lg:p-6 rounded-2xl border border-gray-100 mb-6 relative group hover:border-red-100 transition-colors">
                  <svg className="absolute top-4 left-4 h-6 w-6 text-gray-300 group-hover:text-red-200 transition-colors" fill="currentColor" viewBox="0 0 32 32">
                    <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L25.864 4z" />
                  </svg>
                  <p className="text-base lg:text-lg text-gray-600 italic relative z-10 pl-8 leading-relaxed font-light">
                   <div className="font-bold">Hi, I’m Kinneresh, and my experience with Vignan Online has been truly rewarding.</div>
                    The live classes were interactive, well-structured, and kept me fully engaged throughout the course. What really impressed me was their amazing referral program. I referred nine friends and received a ₹3000 voucher for each referral—which was an incredible bonus!
                    <br />
                    <br />

                    This not only added extra value to my learning journey but also showed how much Vignan Online genuinely appreciates and rewards its students. I’d definitely recommend it to anyone looking for quality online education with real benefits.
                  </p>
                </div>

                {/* Desktop User Info */}
                <div className="pt-4 border-t border-gray-100 items-center">
                  <div className="hidden lg:block">
                    <div className="font-bold text-gray-900 text-base">Kinneresh</div>
                    <div className="text-xs text-gray-500 font-medium">MBA (Healthcare and hospital management)</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="mt-10 flex justify-center sticky bottom-4 z-40 lg:static">
            <div className="backdrop-blur-md p-2 rounded-xl bg-transparent lg:shadow-none lg:border-none lg:p-0">
              {user === null && (
                <CTAButton href="/login" text="Start Referring Now" primary />
              )}
              {["Student", "ExternalVisitor"].includes(user?.user_type) && (
                <CTAButton href="/student" text="Go to Your Dashboard" primary />
              )}
              {["Admin", "SalesHead", "DepartmentHead", "SalesCounselor"].includes(user?.user_type) && (
                <CTAButton href="/sales" text="Go to Sales Dashboard" primary />
              )}
            </div>
          </div>
        </section>

        {/* How It Works Section - Enhanced UI - Dark Theme */}
        <section className="py-16 bg-[#004f6b] relative overflow-hidden">
          {/* Background Texture */}
          <div className="absolute inset-0 opacity-[0.1]" style={{ backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)', backgroundSize: '32px 32px' }}></div>

          <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto relative z-10 px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-10 max-w-2xl mx-auto">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-2">How It Works</h2>
              <p className="text-lg text-blue-100 leading-relaxed">A simple, transparent process designed to help you earn rewards quickly.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
              {/* Continuous Line (Desktop) */}
              <div className="hidden lg:block absolute top-[3.5rem] left-0 w-full h-0.5 bg-white/10 -z-10"></div>

              {refferalBenifits.map((item, index) => (
                <div key={item.id} className="group relative">
                  <div className="h-full bg-white rounded-2xl p-8 shadow-lg border border-white/10 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 hover:bg-[#ebf8ff] relative flex flex-col items-center text-center z-10">

                    {/* Icon Container */}
                    <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mb-6 relative shadow-inner border-4 border-gray-100 group-hover:border-blue-200 transition-colors duration-300">
                      <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center group-hover:bg-red-600 transition-colors duration-300 shadow-lg">
                        <img src={item.image} alt="" className="w-8 h-8 object-contain transition-all duration-300 group-hover:brightness-0 group-hover:invert" />
                      </div>
                      {/* Step Number Badge */}
                      <div className="absolute -bottom-2 bg-[#023e54] text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg border border-white/20 group-hover:bg-red-600 transition-colors">
                        Step {item.count}
                      </div>
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#004f6b] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed group-hover:text-gray-700 transition-colors">
                      {item.content}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
              <p className="text-gray-500">Everything you need to know about the referral program.</p>
            </div>

            <div className="space-y-4">
              {faqMcq.map((item, index) => (
                <div key={index} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300">
                  <button
                    className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none group"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className={`text-lg font-semibold transition-colors duration-200 ${activeIndex === index ? "text-red-700" : "text-gray-900 group-hover:text-red-600"}`}>{item.title}</span>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border transition-all duration-200 ${activeIndex === index ? "bg-red-600 border-red-600 text-white" : "bg-gray-50 border-gray-100 text-gray-400 group-hover:bg-red-50 group-hover:text-red-600"}`}>
                      {activeIndex === index ? (
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                        </svg>
                      ) : (
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                      )}
                    </div>
                  </button>

                  {activeIndex === index && (
                    <div className="px-6 pb-6 animate-fadeIn">
                      <div className="space-y-4 pt-2 border-t border-gray-200/50 mt-2">
                        {item.Insidecontent.map((content, innerIndex) => (
                          <div key={innerIndex} className="bg-gray-50/50 rounded-xl p-5 border border-gray-100 hover:border-red-100 transition-colors">
                            <div
                              className="flex justify-between items-start cursor-pointer select-none group"
                              onClick={() => toggleInnerAccordion(index, innerIndex)}
                            >
                              <h4 className="font-medium text-gray-900 text-base pr-4 group-hover:text-red-600 transition-colors">{content.insideContentTitle}</h4>
                              <span className={`transform transition-transform duration-200 min-w-[1.25rem] ${activeInnerIndex[index] === innerIndex ? "text-red-500" : "text-gray-400"}`}>
                                {activeInnerIndex[index] === innerIndex ? (
                                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                                  </svg>
                                ) : (
                                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                  </svg>
                                )}
                              </span>
                            </div>
                            {activeInnerIndex[index] === innerIndex && (
                              <div className="mt-3 text-gray-600 text-sm leading-relaxed pl-1 border-l-2 border-red-100 ml-1 text-left" dangerouslySetInnerHTML={{ __html: content.insideContentContent }} />
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#004f6b] text-white py-5 border-t border-white/10">
        <div className="max-w-7xl 2xl:max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-2">
              <img src={logo} alt="Vignan Online" className="h-8 w-auto brightness-0 invert opacity-90" />
              <span className="hidden sm:block text-gray-400">|</span>
              <span className="text-sm text-gray-200">
                © {new Date().getFullYear()} VIGNAN Online. All Rights Reserved.
              </span>
            </div>

            <div className="flex space-x-6">
              {[
                { icon: x, href: "https://x.com/vignanonline" },
                { icon: facebook, href: "https://www.facebook.com/vignanonline/" },
                { icon: instagram, href: "https://www.instagram.com/vignanonline/" },
                { icon: linkedin, href: "https://www.linkedin.com/company/vignan-online/" },
                { icon: youtube, href: "https://www.youtube.com/channel/UC9xOL6RM5DShuroZMecmEvg" },
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-white/10 p-2 rounded-full hover:bg-white hover:text-[#004f6b] transition-all transform hover:scale-110 group"
                >
                  <img src={social.icon} alt="Social" className="h-4 w-4 brightness-0 invert group-hover:brightness-0 group-hover:invert-0 transition-all" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
